<template>
  <div class="marketing-block siteblocks hero-block">
    <div class="hero-panel panel">
      <div class="panel-half">
        <img :src="currentHeroImage" class="show" @load="imageLoaded" alt="SiteBlocks Overview"/>
      </div>
     <div class="panel-half">
          <div class="padding">
            <div class="hero-logo-container">
              <img :src="siteblocksBrandImage" class="siteblocks-brand-image" alt="Siteblocks By Bravenet" />
              <img :src="braveAIBrandImage" class="braveai-brand-image" alt="BraveAI Powered" />
            </div>
            <h1 class="title">
              <span>{{$t('sitebuilder.HERO_PANEL_HEADING')}}</span>
            </h1>
            <p v-html="$t('sitebuilder.HERO_PANEL_BODY')"></p>
            <div><md-button to="/sitebuilder/templates" class="md-raised md-primary">{{$t('sitebuilder.HERO_PANEL_CTA')}}</md-button></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.ready = true
    if (window.navigator.userAgent !== 'PRERENDER') {
      // Stuff here
    }
  },
  data: () => {
    let heroImageHiRes = require(`assets/img/sitebuilder/hero-cycle/skii-siteblocks-template.png`)
    let heroImageLowRes = require(`assets/img/sitebuilder/hero-cycle/skii-siteblocks-template.png`)
    let siteblocksBrandImage = require(`assets/img/shared/siteblocks_logo.png`)
    let braveAIBrandImage = require(`assets/img/shared/braveai_powered-1.png`)
    return {
      heroImageHiRes,
      heroImageLowRes,
      currentHeroImage: heroImageLowRes,
      siteblocksBrandImage,
      braveAIBrandImage,
      typedTitle: true,
      ready: false,
      title: '<div/>'
    }
  },
  methods: {
    imageLoaded() {
      this.currentHeroImage = this.heroImageHiRes; // switch to high-res image
    }
  },
  props: [
    'view',
    'hasCTA',
    'clickHandler',
    'href',
  ]
}
</script>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/sitebuilder/hero-panel.vue